import StandardZipInput from './StandardZipInput';
export default StandardZipInput;